import React, { useEffect } from 'react'
import MenuContainer from 'redux/containers/pages/precedentscontent/MenuContainer'
import SectionDetails from 'pages/documentscontent/details/SectionDetails'
import Preview from 'pages/documentscontent/Preview'
import NotFound from 'components/NotFound'
import ConnectedPrecedentsAdmin from 'pages/documentscontent/precedentsadmin/ConnectedPrecedentsAdmin'

// TODO: investigate if prop drilling userDetails down to Main component is actually useful here
const PermissionsCheck = ({ userDetails, ...props }) => {
  const {
    view,
    setView,
    sectionId,
    setSectionId,
    precedentId,
    setPrecedentId,
    isAdmin,
    expandedSection,
    setExpandedSection
  } = props

  useEffect(() => {
    setView(view)
  }, [view])

  useEffect(() => {
    setSectionId(sectionId)
  }, [sectionId])

  useEffect(() => {
    setPrecedentId(precedentId)
  }, [precedentId])

  useEffect(() => {
    setExpandedSection(expandedSection)
  }, [expandedSection])

  let Main
  switch (view) {
    case 'browse':
    case 'related':
      Main = sectionId ? SectionDetails : MenuContainer
      break
    default:
      Main = NotFound
  }

  // If admin is requesting a specific precedent or creating a new one
  if (precedentId) {
    if (isAdmin) {
      Main = ConnectedPrecedentsAdmin
    } else {
      Main = Preview
    }
  }

  return <Main {...{ ...userDetails, ...props }} />
}

export default PermissionsCheck
